var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ckeditor4",class:{'myDisabled':_vm.disabled}},[_c('textarea',{attrs:{"id":_vm.id,"disabled":_vm.disabled}})])
}
var staticRenderFns = []

export { render, staticRenderFns }